import { ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { CommunicationSizeComponent, PlacementResult } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { getIsShelf } from '../utils/utils';
import { isProduction } from 'utils/platform';
import { AutoAdaptAccessoriesSystem } from '@inter-ikea-storageone/range-pax';

const replaceOrganizer = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  },
  props
}: BehaviorParameters) => {
  const devMode = !isProduction();
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) {
    return;
  }
  const parent = HierarchyUtils.parent(selectedEntity);
  const selectedEntityWidth = selectedEntity.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size.width;
  const selectedEntityType = coreApi.entities.getProductType(selectedEntity);

  const replaceProduct = () => {
    const placementResult = coreApi.products.removeAndAdd(selectedEntity.id, props.coreProductId);
    if (placementResult?.valid && placementResult.placedEntity) {
      coreApi.entities.select(placementResult.placedEntity);
    } else if (placementResult && !placementResult?.valid && devMode) {
      // eslint-disable-next-line no-console
      console.warn('invalid placement when trying to place a storage case', placementResult);
    }
  };

  const addProduct = () => {
    if (!parent) return;
    if (
      getIsShelf(coreApi, parent.id) ||
      coreApi.entities.isProductType(parent, ProductType.PAX_FRAME) ||
      coreApi.entities.isProductType(parent, ProductType.PAX_T_DIVIDER)
    ) {
      const placementResult = coreApi.products.addToTarget(props.coreProductId, parent);

      warnIfFailedOrReportAddProductSuccess(placementResult);
    }
  };

  const warnIfFailedOrReportAddProductSuccess = (placementResult: PlacementResult) => {
    if (placementResult) {
      if (!placementResult.valid) {
        // eslint-disable-next-line no-console
        console.warn('invalid placement when trying to place a storage case');
      }
    }
  };

  coreApi.validations['AccessoriesPlacementValidation']?.disable();
  coreApi.getSystem<AutoAdaptAccessoriesSystem>('AutoAdaptAccessoriesSystem')?.disable();

  replaceProduct();

  const targetProduct = products.find(product => product.coreProductId === props.coreProductId);

  // Only add a second SKUBB box if we change from a 100cm wide box to a 50cm wide
  if (
    selectedEntityType === ProductType.PAX_SKUBB_STORAGE_CASES &&
    selectedEntityWidth === 1000 &&
    targetProduct?.communicatedDimensions.width === 500
  ) {
    addProduct();
  }

  coreApi.validations['AccessoriesPlacementValidation']?.enable();
  coreApi.getSystem<AutoAdaptAccessoriesSystem>('AutoAdaptAccessoriesSystem')?.enable();
};

export default replaceOrganizer;
